import React from "react"

const Icon = props => {
  const surfaceScale = props.theme === "light" ? "1" : "10"
  const opacity = props.width > 100 ? 0.41 : 0.1
  //const noiseColor = props.theme === "light" ? "#f2f2f2" : "#917c6f"
  //const fillOpacity = props.theme === "light" ? "0.9" : "1"

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width} //"326.441"
      //      height="371.017"
      version="1.1"
      viewBox="0 0 326.441 371.017"
      className="texture-medal-shining"
      opacity="0"
      style={props.style}
    >
      <defs>
        <linearGradient
          id="MyGradient"
          gradientTransform="skewX(27) rotate(45)"
        >
          <stop
            className="linearGradient-stop-1"
            stopColor="rgba(255,143,0,.4)"
          >
            {/* {true && ( */}
              <animate
                id="op1"
                attributeName="offset"
                from="0"
                to="1"
                dur="1s"
                begin=".5s;op1.end+3s"
              />
            {/* )} */}
          </stop>
          <stop
            className="linearGradient-stop-2"
            id="linearGradient-stop-2"
            stopColor="rgba(255,255,255,.7)"
          >
            {/* {true && ( */}
              <animate
                id="op2"
                attributeName="offset"
                from="0.2"
                to="1"
                dur=".8s"
                begin=".5s;op2.end+3.2s"
              />
            {/* )} */}
          </stop>
          <stop
            className="linearGradient-stop-3"
            stopColor="rgba(255,143,0,.4)"
          >
            {/* {true && ( */}
              <animate
                id="op3"
                attributeName="offset"
                from=".5"
                to="1"
                dur=".5s"
                begin=".5s;op3.end+3.5s"
              />
            {/* )} */}
          </stop>
        </linearGradient>
        <filter colorInterpolationFilters="sRGB">
          <feOffset dx="3" dy="3"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#000" floodOpacity="1" result="flood"></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="in"
            result="composite"
          ></feComposite>
          <feBlend in="blur" in2="composite" mode="normal"></feBlend>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feOffset dx="3" dy="3"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#000" floodOpacity="1" result="flood"></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="in"
            result="composite"
          ></feComposite>
          <feBlend in="blur" in2="composite" mode="normal"></feBlend>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feOffset dx="3" dy="3"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#000" floodOpacity="1" result="flood"></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="in"
            result="composite"
          ></feComposite>
          <feBlend in="blur" in2="composite" mode="normal"></feBlend>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feOffset dx="3" dy="3"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#000" floodOpacity="1" result="flood"></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="in"
            result="composite"
          ></feComposite>
          <feBlend in="blur" in2="composite" mode="normal"></feBlend>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feOffset dx="3" dy="3"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#000" floodOpacity="1" result="flood"></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="in"
            result="composite"
          ></feComposite>
          <feBlend in="blur" in2="composite" mode="normal"></feBlend>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feOffset dx="3" dy="3"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#000" floodOpacity="1" result="flood"></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="in"
            result="composite"
          ></feComposite>
          <feBlend in="blur" in2="composite" mode="normal"></feBlend>
        </filter>
        <filter height="1.5" y="-0.25" colorInterpolationFilters="sRGB">
          <feGaussianBlur result="result6" stdDeviation="5"></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result6"
            operator="atop"
            result="result8"
          ></feComposite>
          <feComposite
            in="result8"
            in2="SourceAlpha"
            operator="over"
            result="result9"
          ></feComposite>
          <feColorMatrix
            result="result10"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend in="result10" in2="result6" mode="normal"></feBlend>
        </filter>
        <filter height="1.5" y="-0.25" colorInterpolationFilters="sRGB">
          <feGaussianBlur result="result6" stdDeviation="5"></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result6"
            operator="atop"
            result="result8"
          ></feComposite>
          <feComposite
            in="result8"
            in2="SourceAlpha"
            operator="over"
            result="result9"
          ></feComposite>
          <feColorMatrix
            result="result10"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend in="result10" in2="result6" mode="normal"></feBlend>
        </filter>
        <filter height="1.5" y="-0.25" colorInterpolationFilters="sRGB">
          <feGaussianBlur result="result6" stdDeviation="5"></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result6"
            operator="atop"
            result="result8"
          ></feComposite>
          <feComposite
            in="result8"
            in2="SourceAlpha"
            operator="over"
            result="result9"
          ></feComposite>
          <feColorMatrix
            result="result10"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend in="result10" in2="result6" mode="normal"></feBlend>
        </filter>
        <filter height="1.5" y="-0.25" colorInterpolationFilters="sRGB">
          <feGaussianBlur result="result6" stdDeviation="5"></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result6"
            operator="atop"
            result="result8"
          ></feComposite>
          <feComposite
            in="result8"
            in2="SourceAlpha"
            operator="over"
            result="result9"
          ></feComposite>
          <feColorMatrix
            result="result10"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend in="result10" in2="result6" mode="normal"></feBlend>
        </filter>
        <filter height="1.5" y="-0.25" colorInterpolationFilters="sRGB">
          <feGaussianBlur result="result6" stdDeviation="5"></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result6"
            operator="atop"
            result="result8"
          ></feComposite>
          <feComposite
            in="result8"
            in2="SourceAlpha"
            operator="over"
            result="result9"
          ></feComposite>
          <feColorMatrix
            result="result10"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend in="result10" in2="result6" mode="normal"></feBlend>
        </filter>
        <filter height="1.5" y="-0.25" colorInterpolationFilters="sRGB">
          <feGaussianBlur result="result6" stdDeviation="5"></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result6"
            operator="atop"
            result="result8"
          ></feComposite>
          <feComposite
            in="result8"
            in2="SourceAlpha"
            operator="over"
            result="result9"
          ></feComposite>
          <feColorMatrix
            result="result10"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend in="result10" in2="result6" mode="normal"></feBlend>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feFlood
            floodColor="#000"
            floodOpacity="0.498"
            result="flood"
          ></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="out"
            result="composite1"
          ></feComposite>
          <feGaussianBlur
            in="composite1"
            result="blur"
            stdDeviation="3"
          ></feGaussianBlur>
          <feOffset dx="6" dy="6" result="offset"></feOffset>
          <feComposite
            in="offset"
            in2="SourceGraphic"
            operator="atop"
            result="composite2"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feFlood
            floodColor="#000"
            floodOpacity="0.498"
            result="flood"
          ></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="out"
            result="composite1"
          ></feComposite>
          <feGaussianBlur
            in="composite1"
            result="blur"
            stdDeviation="3"
          ></feGaussianBlur>
          <feOffset dx="6" dy="6" result="offset"></feOffset>
          <feComposite
            in="offset"
            in2="SourceGraphic"
            operator="atop"
            result="composite2"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feFlood
            floodColor="#000"
            floodOpacity="0.498"
            result="flood"
          ></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="out"
            result="composite1"
          ></feComposite>
          <feGaussianBlur
            in="composite1"
            result="blur"
            stdDeviation="3"
          ></feGaussianBlur>
          <feOffset dx="6" dy="6" result="offset"></feOffset>
          <feComposite
            in="offset"
            in2="SourceGraphic"
            operator="atop"
            result="composite2"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feFlood
            floodColor="#000"
            floodOpacity="0.498"
            result="flood"
          ></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="out"
            result="composite1"
          ></feComposite>
          <feGaussianBlur
            in="composite1"
            result="blur"
            stdDeviation="3"
          ></feGaussianBlur>
          <feOffset dx="6" dy="6" result="offset"></feOffset>
          <feComposite
            in="offset"
            in2="SourceGraphic"
            operator="atop"
            result="composite2"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feFlood
            floodColor="#000"
            floodOpacity="0.498"
            result="flood"
          ></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="out"
            result="composite1"
          ></feComposite>
          <feGaussianBlur
            in="composite1"
            result="blur"
            stdDeviation="3"
          ></feGaussianBlur>
          <feOffset dx="6" dy="6" result="offset"></feOffset>
          <feComposite
            in="offset"
            in2="SourceGraphic"
            operator="atop"
            result="composite2"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feFlood
            floodColor="#000"
            floodOpacity="0.498"
            result="flood"
          ></feFlood>
          <feComposite
            in="flood"
            in2="SourceGraphic"
            operator="out"
            result="composite1"
          ></feComposite>
          <feGaussianBlur
            in="composite1"
            result="blur"
            stdDeviation="3"
          ></feGaussianBlur>
          <feOffset dx="6" dy="6" result="offset"></feOffset>
          <feComposite
            in="offset"
            in2="SourceGraphic"
            operator="atop"
            result="composite2"
          ></feComposite>
        </filter>
        <filter id="filter4206" colorInterpolationFilters="sRGB">
          <feColorMatrix
            in="SourceGraphic"
            result="result1"
            type="saturate"
            values="0.37"
          ></feColorMatrix>
          <feGaussianBlur in="SourceAlpha" stdDeviation="7"></feGaussianBlur>
          <feSpecularLighting
            specularConstant="3.88"
            specularExponent="8"
            surfaceScale={surfaceScale}
          >
            <feDistantLight azimuth="225" elevation="17"></feDistantLight>
          </feSpecularLighting>
          <feComposite in2="result1" operator="atop"></feComposite>
        </filter>
        <filter id="filter4218" colorInterpolationFilters="sRGB">
          <feColorMatrix
            in="SourceGraphic"
            result="result1"
            type="saturate"
            values="0.37"
          ></feColorMatrix>
          <feGaussianBlur in="SourceAlpha" stdDeviation="7"></feGaussianBlur>
          <feSpecularLighting
            specularConstant="3.88"
            specularExponent="8"
            surfaceScale={surfaceScale}
          >
            <feDistantLight azimuth="225" elevation="17"></feDistantLight>
          </feSpecularLighting>
          <feComposite in2="result1" operator="atop"></feComposite>
        </filter>
        <filter id="filter4230" colorInterpolationFilters="sRGB">
          <feColorMatrix
            in="SourceGraphic"
            result="result1"
            type="saturate"
            values="0.37"
          ></feColorMatrix>
          <feGaussianBlur in="SourceAlpha" stdDeviation="7"></feGaussianBlur>
          <feSpecularLighting
            specularConstant="3.88"
            specularExponent="8"
            surfaceScale={surfaceScale}
          >
            <feDistantLight azimuth="225" elevation="17"></feDistantLight>
          </feSpecularLighting>
          <feComposite in2="result1" operator="atop"></feComposite>
        </filter>
        <filter id="filter4242" colorInterpolationFilters="sRGB">
          <feColorMatrix
            in="SourceGraphic"
            result="result1"
            type="saturate"
            values="0.37"
          ></feColorMatrix>
          <feGaussianBlur in="SourceAlpha" stdDeviation="7"></feGaussianBlur>
          <feSpecularLighting
            specularConstant="3.88"
            specularExponent="8"
            surfaceScale={surfaceScale}
          >
            <feDistantLight azimuth="225" elevation="17"></feDistantLight>
          </feSpecularLighting>
          <feComposite in2="result1" operator="atop"></feComposite>
        </filter>
        <filter id="filter4254" colorInterpolationFilters="sRGB">
          <feColorMatrix
            in="SourceGraphic"
            result="result1"
            type="saturate"
            values="0.37"
          ></feColorMatrix>
          <feGaussianBlur in="SourceAlpha" stdDeviation="7"></feGaussianBlur>
          <feSpecularLighting
            specularConstant="3.88"
            specularExponent="8"
            surfaceScale={surfaceScale}
          >
            <feDistantLight azimuth="225" elevation="17"></feDistantLight>
          </feSpecularLighting>
          <feComposite in2="result1" operator="atop"></feComposite>
        </filter>
        <filter id="filter4266" colorInterpolationFilters="sRGB">
          <feColorMatrix
            in="SourceGraphic"
            result="result1"
            type="saturate"
            values="0.37"
          ></feColorMatrix>
          <feGaussianBlur in="SourceAlpha" stdDeviation="7"></feGaussianBlur>
          <feSpecularLighting
            specularConstant="3.88"
            specularExponent="8"
            surfaceScale={surfaceScale}
          >
            <feDistantLight azimuth="225" elevation="17"></feDistantLight>
          </feSpecularLighting>
          <feComposite in2="result1" operator="atop"></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceGraphic"
            radius="4"
            result="result0"
          ></feMorphology>
          <feGaussianBlur
            in="result0"
            result="result91"
            stdDeviation="8"
          ></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result91"
            operator="in"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceGraphic"
            radius="4"
            result="result0"
          ></feMorphology>
          <feGaussianBlur
            in="result0"
            result="result91"
            stdDeviation="8"
          ></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result91"
            operator="in"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceGraphic"
            radius="4"
            result="result0"
          ></feMorphology>
          <feGaussianBlur
            in="result0"
            result="result91"
            stdDeviation="8"
          ></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result91"
            operator="in"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceGraphic"
            radius="4"
            result="result0"
          ></feMorphology>
          <feGaussianBlur
            in="result0"
            result="result91"
            stdDeviation="8"
          ></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result91"
            operator="in"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceGraphic"
            radius="4"
            result="result0"
          ></feMorphology>
          <feGaussianBlur
            in="result0"
            result="result91"
            stdDeviation="8"
          ></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result91"
            operator="in"
          ></feComposite>
        </filter>
        <filter colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceGraphic"
            radius="4"
            result="result0"
          ></feMorphology>
          <feGaussianBlur
            in="result0"
            result="result91"
            stdDeviation="8"
          ></feGaussianBlur>
          <feComposite
            in="SourceGraphic"
            in2="result91"
            operator="in"
          ></feComposite>
        </filter>
        <filter
          width="1.4"
          height="1.4"
          x="-0.2"
          y="-0.2"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur result="result14" stdDeviation="1"></feGaussianBlur>
          <feFlood
            floodColor="#37C871"
            floodOpacity="1"
            result="result15"
          ></feFlood>
          <feTurbulence
            baseFrequency="0.004 0.008"
            numOctaves="1"
            result="result5"
            seed="25"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="result5"
            in2="result14"
            result="result8"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="B"
          ></feDisplacementMap>
          <feGaussianBlur result="result17" stdDeviation="1"></feGaussianBlur>
          <feSpecularLighting
            in="result8"
            lightingColor="#fff"
            result="result2"
            specularConstant="1"
            specularExponent="50"
            surfaceScale="-10"
          >
            <feDistantLight azimuth="225" elevation="80"></feDistantLight>
          </feSpecularLighting>
          <feBlend in2="SourceGraphic" mode="screen" result="result9"></feBlend>
          <feComposite
            in2="SourceGraphic"
            operator="atop"
            result="result11"
          ></feComposite>
          <feDisplacementMap
            in="result11"
            in2="result5"
            result="result16"
            scale="0"
            xChannelSelector="R"
            yChannelSelector="A"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.4"
          height="1.4"
          x="-0.2"
          y="-0.2"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur result="result14" stdDeviation="1"></feGaussianBlur>
          <feFlood
            floodColor="#37C871"
            floodOpacity="1"
            result="result15"
          ></feFlood>
          <feTurbulence
            baseFrequency="0.004 0.008"
            numOctaves="1"
            result="result5"
            seed="25"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="result5"
            in2="result14"
            result="result8"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="B"
          ></feDisplacementMap>
          <feGaussianBlur result="result17" stdDeviation="1"></feGaussianBlur>
          <feSpecularLighting
            in="result8"
            lightingColor="#fff"
            result="result2"
            specularConstant="1"
            specularExponent="50"
            surfaceScale="-10"
          >
            <feDistantLight azimuth="225" elevation="80"></feDistantLight>
          </feSpecularLighting>
          <feBlend in2="SourceGraphic" mode="screen" result="result9"></feBlend>
          <feComposite
            in2="SourceGraphic"
            operator="atop"
            result="result11"
          ></feComposite>
          <feDisplacementMap
            in="result11"
            in2="result5"
            result="result16"
            scale="0"
            xChannelSelector="R"
            yChannelSelector="A"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.4"
          height="1.4"
          x="-0.2"
          y="-0.2"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur result="result14" stdDeviation="1"></feGaussianBlur>
          <feFlood
            floodColor="#37C871"
            floodOpacity="1"
            result="result15"
          ></feFlood>
          <feTurbulence
            baseFrequency="0.004 0.008"
            numOctaves="1"
            result="result5"
            seed="25"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="result5"
            in2="result14"
            result="result8"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="B"
          ></feDisplacementMap>
          <feGaussianBlur result="result17" stdDeviation="1"></feGaussianBlur>
          <feSpecularLighting
            in="result8"
            lightingColor="#fff"
            result="result2"
            specularConstant="1"
            specularExponent="50"
            surfaceScale="-10"
          >
            <feDistantLight azimuth="225" elevation="80"></feDistantLight>
          </feSpecularLighting>
          <feBlend in2="SourceGraphic" mode="screen" result="result9"></feBlend>
          <feComposite
            in2="SourceGraphic"
            operator="atop"
            result="result11"
          ></feComposite>
          <feDisplacementMap
            in="result11"
            in2="result5"
            result="result16"
            scale="0"
            xChannelSelector="R"
            yChannelSelector="A"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.4"
          height="1.4"
          x="-0.2"
          y="-0.2"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur result="result14" stdDeviation="1"></feGaussianBlur>
          <feFlood
            floodColor="#37C871"
            floodOpacity="1"
            result="result15"
          ></feFlood>
          <feTurbulence
            baseFrequency="0.004 0.008"
            numOctaves="1"
            result="result5"
            seed="25"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="result5"
            in2="result14"
            result="result8"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="B"
          ></feDisplacementMap>
          <feGaussianBlur result="result17" stdDeviation="1"></feGaussianBlur>
          <feSpecularLighting
            in="result8"
            lightingColor="#fff"
            result="result2"
            specularConstant="1"
            specularExponent="50"
            surfaceScale="-10"
          >
            <feDistantLight azimuth="225" elevation="80"></feDistantLight>
          </feSpecularLighting>
          <feBlend in2="SourceGraphic" mode="screen" result="result9"></feBlend>
          <feComposite
            in2="SourceGraphic"
            operator="atop"
            result="result11"
          ></feComposite>
          <feDisplacementMap
            in="result11"
            in2="result5"
            result="result16"
            scale="0"
            xChannelSelector="R"
            yChannelSelector="A"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.4"
          height="1.4"
          x="-0.2"
          y="-0.2"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur result="result14" stdDeviation="1"></feGaussianBlur>
          <feFlood
            floodColor="#37C871"
            floodOpacity="1"
            result="result15"
          ></feFlood>
          <feTurbulence
            baseFrequency="0.004 0.008"
            numOctaves="1"
            result="result5"
            seed="25"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="result5"
            in2="result14"
            result="result8"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="B"
          ></feDisplacementMap>
          <feGaussianBlur result="result17" stdDeviation="1"></feGaussianBlur>
          <feSpecularLighting
            in="result8"
            lightingColor="#fff"
            result="result2"
            specularConstant="1"
            specularExponent="50"
            surfaceScale="-10"
          >
            <feDistantLight azimuth="225" elevation="80"></feDistantLight>
          </feSpecularLighting>
          <feBlend in2="SourceGraphic" mode="screen" result="result9"></feBlend>
          <feComposite
            in2="SourceGraphic"
            operator="atop"
            result="result11"
          ></feComposite>
          <feDisplacementMap
            in="result11"
            in2="result5"
            result="result16"
            scale="0"
            xChannelSelector="R"
            yChannelSelector="A"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.4"
          height="1.4"
          x="-0.2"
          y="-0.2"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur result="result14" stdDeviation="1"></feGaussianBlur>
          <feFlood
            floodColor="#37C871"
            floodOpacity="1"
            result="result15"
          ></feFlood>
          <feTurbulence
            baseFrequency="0.004 0.008"
            numOctaves="1"
            result="result5"
            seed="25"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="result5"
            in2="result14"
            result="result8"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="B"
          ></feDisplacementMap>
          <feGaussianBlur result="result17" stdDeviation="1"></feGaussianBlur>
          <feSpecularLighting
            in="result8"
            lightingColor="#fff"
            result="result2"
            specularConstant="1"
            specularExponent="50"
            surfaceScale="-10"
          >
            <feDistantLight azimuth="225" elevation="80"></feDistantLight>
          </feSpecularLighting>
          <feBlend in2="SourceGraphic" mode="screen" result="result9"></feBlend>
          <feComposite
            in2="SourceGraphic"
            operator="atop"
            result="result11"
          ></feComposite>
          <feDisplacementMap
            in="result11"
            in2="result5"
            result="result16"
            scale="0"
            xChannelSelector="R"
            yChannelSelector="A"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.6"
          height="2"
          x="-0.3"
          y="-0.5"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            baseFrequency="0.4"
            numOctaves="5"
            result="result1"
            seed="0"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="SourceGraphic"
            in2="result1"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.6"
          height="2"
          x="-0.3"
          y="-0.5"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            baseFrequency="0.4"
            numOctaves="5"
            result="result1"
            seed="0"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="SourceGraphic"
            in2="result1"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.6"
          height="2"
          x="-0.3"
          y="-0.5"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            baseFrequency="0.4"
            numOctaves="5"
            result="result1"
            seed="0"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="SourceGraphic"
            in2="result1"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.6"
          height="2"
          x="-0.3"
          y="-0.5"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            baseFrequency="0.4"
            numOctaves="5"
            result="result1"
            seed="0"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="SourceGraphic"
            in2="result1"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.6"
          height="2"
          x="-0.3"
          y="-0.5"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            baseFrequency="0.4"
            numOctaves="5"
            result="result1"
            seed="0"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="SourceGraphic"
            in2="result1"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.6"
          height="2"
          x="-0.3"
          y="-0.5"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            baseFrequency="0.4"
            numOctaves="5"
            result="result1"
            seed="0"
            type="fractalNoise"
          ></feTurbulence>
          <feDisplacementMap
            in="SourceGraphic"
            in2="result1"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          ></feDisplacementMap>
        </filter>
        <filter
          width="1.5"
          height="1.5"
          x="-0.25"
          y="-0.25"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur
            in="SourceGraphic"
            result="result8"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="result8"
            operator="xor"
            result="result19"
          ></feComposite>
          <feComposite
            in2="result8"
            k1="0"
            k2="1"
            k3="0"
            k4="0"
            operator="arithmetic"
            result="result17"
          ></feComposite>
          <feOffset in="result8" result="result18"></feOffset>
          <feDisplacementMap
            in="result18"
            in2="result17"
            result="result4"
            scale="100"
            xChannelSelector="A"
            yChannelSelector="A"
          ></feDisplacementMap>
          <feComposite
            in="SourceGraphic"
            in2="result4"
            k1="1"
            k2="0"
            k3="1"
            k4="0"
            operator="arithmetic"
            result="result2"
          ></feComposite>
          <feComposite
            in="result2"
            in2="SourceGraphic"
            operator="in"
            result="fbSourceGraphic"
          ></feComposite>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="result15"
          ></feComposite>
          <feComposite
            in="result15"
            in2="SourceGraphic"
            operator="in"
            result="result16"
          ></feComposite>
        </filter>
        <filter
          width="1.5"
          height="1.5"
          x="-0.25"
          y="-0.25"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur
            in="SourceGraphic"
            result="result8"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="result8"
            operator="xor"
            result="result19"
          ></feComposite>
          <feComposite
            in2="result8"
            k1="0"
            k2="1"
            k3="0"
            k4="0"
            operator="arithmetic"
            result="result17"
          ></feComposite>
          <feOffset in="result8" result="result18"></feOffset>
          <feDisplacementMap
            in="result18"
            in2="result17"
            result="result4"
            scale="100"
            xChannelSelector="A"
            yChannelSelector="A"
          ></feDisplacementMap>
          <feComposite
            in="SourceGraphic"
            in2="result4"
            k1="1"
            k2="0"
            k3="1"
            k4="0"
            operator="arithmetic"
            result="result2"
          ></feComposite>
          <feComposite
            in="result2"
            in2="SourceGraphic"
            operator="in"
            result="fbSourceGraphic"
          ></feComposite>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="result15"
          ></feComposite>
          <feComposite
            in="result15"
            in2="SourceGraphic"
            operator="in"
            result="result16"
          ></feComposite>
        </filter>
        <filter
          width="1.5"
          height="1.5"
          x="-0.25"
          y="-0.25"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur
            in="SourceGraphic"
            result="result8"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="result8"
            operator="xor"
            result="result19"
          ></feComposite>
          <feComposite
            in2="result8"
            k1="0"
            k2="1"
            k3="0"
            k4="0"
            operator="arithmetic"
            result="result17"
          ></feComposite>
          <feOffset in="result8" result="result18"></feOffset>
          <feDisplacementMap
            in="result18"
            in2="result17"
            result="result4"
            scale="100"
            xChannelSelector="A"
            yChannelSelector="A"
          ></feDisplacementMap>
          <feComposite
            in="SourceGraphic"
            in2="result4"
            k1="1"
            k2="0"
            k3="1"
            k4="0"
            operator="arithmetic"
            result="result2"
          ></feComposite>
          <feComposite
            in="result2"
            in2="SourceGraphic"
            operator="in"
            result="fbSourceGraphic"
          ></feComposite>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="result15"
          ></feComposite>
          <feComposite
            in="result15"
            in2="SourceGraphic"
            operator="in"
            result="result16"
          ></feComposite>
        </filter>
        <filter
          width="1.5"
          height="1.5"
          x="-0.25"
          y="-0.25"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur
            in="SourceGraphic"
            result="result8"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="result8"
            operator="xor"
            result="result19"
          ></feComposite>
          <feComposite
            in2="result8"
            k1="0"
            k2="1"
            k3="0"
            k4="0"
            operator="arithmetic"
            result="result17"
          ></feComposite>
          <feOffset in="result8" result="result18"></feOffset>
          <feDisplacementMap
            in="result18"
            in2="result17"
            result="result4"
            scale="100"
            xChannelSelector="A"
            yChannelSelector="A"
          ></feDisplacementMap>
          <feComposite
            in="SourceGraphic"
            in2="result4"
            k1="1"
            k2="0"
            k3="1"
            k4="0"
            operator="arithmetic"
            result="result2"
          ></feComposite>
          <feComposite
            in="result2"
            in2="SourceGraphic"
            operator="in"
            result="fbSourceGraphic"
          ></feComposite>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="result15"
          ></feComposite>
          <feComposite
            in="result15"
            in2="SourceGraphic"
            operator="in"
            result="result16"
          ></feComposite>
        </filter>
        <filter
          width="1.5"
          height="1.5"
          x="-0.25"
          y="-0.25"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur
            in="SourceGraphic"
            result="result8"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="result8"
            operator="xor"
            result="result19"
          ></feComposite>
          <feComposite
            in2="result8"
            k1="0"
            k2="1"
            k3="0"
            k4="0"
            operator="arithmetic"
            result="result17"
          ></feComposite>
          <feOffset in="result8" result="result18"></feOffset>
          <feDisplacementMap
            in="result18"
            in2="result17"
            result="result4"
            scale="100"
            xChannelSelector="A"
            yChannelSelector="A"
          ></feDisplacementMap>
          <feComposite
            in="SourceGraphic"
            in2="result4"
            k1="1"
            k2="0"
            k3="1"
            k4="0"
            operator="arithmetic"
            result="result2"
          ></feComposite>
          <feComposite
            in="result2"
            in2="SourceGraphic"
            operator="in"
            result="fbSourceGraphic"
          ></feComposite>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="result15"
          ></feComposite>
          <feComposite
            in="result15"
            in2="SourceGraphic"
            operator="in"
            result="result16"
          ></feComposite>
        </filter>
        <filter
          width="1.5"
          height="1.5"
          x="-0.25"
          y="-0.25"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur
            in="SourceGraphic"
            result="result8"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="result8"
            operator="xor"
            result="result19"
          ></feComposite>
          <feComposite
            in2="result8"
            k1="0"
            k2="1"
            k3="0"
            k4="0"
            operator="arithmetic"
            result="result17"
          ></feComposite>
          <feOffset in="result8" result="result18"></feOffset>
          <feDisplacementMap
            in="result18"
            in2="result17"
            result="result4"
            scale="100"
            xChannelSelector="A"
            yChannelSelector="A"
          ></feDisplacementMap>
          <feComposite
            in="SourceGraphic"
            in2="result4"
            k1="1"
            k2="0"
            k3="1"
            k4="0"
            operator="arithmetic"
            result="result2"
          ></feComposite>
          <feComposite
            in="result2"
            in2="SourceGraphic"
            operator="in"
            result="fbSourceGraphic"
          ></feComposite>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="result15"
          ></feComposite>
          <feComposite
            in="result15"
            in2="SourceGraphic"
            operator="in"
            result="result16"
          ></feComposite>
        </filter>
        <filter
          id="filter11505"
          width="2.973"
          height="3.163"
          x="-0.987"
          y="-1.082"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="27.448"></feGaussianBlur>
        </filter>
        <filter
          id="filter11509"
          width="2.919"
          height="3.298"
          x="-0.959"
          y="-1.149"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="27.448"></feGaussianBlur>
        </filter>
        <filter
          id="filter11513"
          width="4.985"
          height="5.035"
          x="-1.993"
          y="-2.018"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="27.448"></feGaussianBlur>
        </filter>
        <filter
          id="filter11517"
          width="4.979"
          height="5.047"
          x="-1.989"
          y="-2.024"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="27.448"></feGaussianBlur>
        </filter>
        <filter
          id="filter11521"
          width="1.977"
          height="1.979"
          x="-0.489"
          y="-0.49"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="27.448"></feGaussianBlur>
        </filter>
        <filter
          id="filter11525"
          width="1.677"
          height="1.676"
          x="-0.338"
          y="-0.338"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="27.448"></feGaussianBlur>
        </filter>
        <filter id="filter12677" colorInterpolationFilters="sRGB">
          <feTurbulence
            baseFrequency="8.26203 5.18717"
            numOctaves="2"
            result="turbulence"
            seed="118"
            type="turbulence"
          ></feTurbulence>
          <feComposite
            in="SourceGraphic"
            in2="turbulence"
            operator="out"
            result="composite1"
          ></feComposite>
          <feColorMatrix
            result="color"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 3.36 -3.11"
          ></feColorMatrix>
          <feFlood
            floodColor="#152839"
            floodOpacity="0"
            result="flood"
          ></feFlood>
          <feMerge result="merge">
            <feMergeNode in="flood"></feMergeNode>
            <feMergeNode in="color"></feMergeNode>
          </feMerge>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="composite2"
          ></feComposite>
        </filter>
        <filter id="filter13171" colorInterpolationFilters="sRGB">
          <feTurbulence
            baseFrequency="8.26203 5.18717"
            numOctaves="2"
            result="turbulence"
            seed="118"
            type="turbulence"
          ></feTurbulence>
          <feComposite
            in="SourceGraphic"
            in2="turbulence"
            operator="out"
            result="composite1"
          ></feComposite>
          <feColorMatrix
            result="color"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 3.36 -3.01"
          ></feColorMatrix>
          <feFlood
            floodColor="#152839"
            floodOpacity="0"
            result="flood"
          ></feFlood>
          <feMerge result="merge">
            <feMergeNode in="flood"></feMergeNode>
            <feMergeNode in="color"></feMergeNode>
          </feMerge>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="composite2"
          ></feComposite>
        </filter>
        <filter id="filter13189" colorInterpolationFilters="sRGB">
          <feTurbulence
            baseFrequency="8.26203 5.18717"
            numOctaves="2"
            result="turbulence"
            seed="118"
            type="turbulence"
          ></feTurbulence>
          <feComposite
            in="SourceGraphic"
            in2="turbulence"
            operator="out"
            result="composite1"
          ></feComposite>
          <feColorMatrix
            result="color"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 3.36 -2.91"
          ></feColorMatrix>
          <feFlood
            floodColor="#152839"
            floodOpacity="0"
            result="flood"
          ></feFlood>
          <feMerge result="merge">
            <feMergeNode in="flood"></feMergeNode>
            <feMergeNode in="color"></feMergeNode>
          </feMerge>
          <feComposite
            in2="SourceGraphic"
            operator="in"
            result="composite2"
          ></feComposite>
        </filter>
      </defs>
      <g
        fill="#ff8f00"
        fillOpacity={0}
        stroke="none"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.8"
        display="inline"
        transform="translate(65.454 66.806)"
        className={"main-blur-" + props.styleMode + "-" + props.theme}
      >
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M97.063-.93C84.251-.763 77.644 16.468 65.88 21.544c-11.821 5.101-29.03-1.828-37.926 7.305s-1.424 25.67-6.182 37.363C17.082 77.738.436 84.392.421 96.835c-.016 12.651 16.806 19.49 21.632 31.184 4.682 11.342-1.997 27.352 6.461 36.242 9.207 9.677 26.786 3.701 39.051 8.99 11.472 4.947 18.69 20.802 31.184 20.79 12.96-.014 20.42-16.473 32.308-21.633 11.732-5.092 28.669.667 37.366-8.71 8.313-8.962 1.152-24.86 5.619-36.24 4.583-11.677 21.081-18.64 21.07-31.185-.011-13.013-16.807-20.338-21.914-32.307-4.923-11.538 2.237-26.357-6.742-35.117-9.072-8.85-26.777-3.866-38.488-8.709C116.446 15.376 109.53-1.093 97.063-.93zm.563 27.414a70.633 70.633 0 0170.633 70.633 70.633 70.633 0 01-70.633 70.632 70.633 70.633 0 01-70.633-70.632 70.633 70.633 0 0170.633-70.633z"
          display="inline"
          filter="url(#filter11525)"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M98.608 28.732c-37.237 0-67.423 30.124-67.424 67.283 0 37.16 30.187 67.284 67.424 67.285 37.238 0 67.426-30.124 67.426-67.285 0-37.16-30.188-67.284-67.426-67.283zm-.56 11.517c31.186.001 56.466 25.22 56.466 56.328 0 31.109-25.28 56.328-56.466 56.329a56.87 56.87 0 01-10.881-1.047c.742-1.783 8.493-20.362 13.142-29.262 4.277-8.266 7.29-7.595 9.535-7.549 2.517.021 5.563-3.974 5.563-3.974s13.224-27.6 16.092-35.559c.846-2.44-1.626-2.217-2.186-.992-2.665 5.425-13.756 27.896-16.588 33.076-1.762.893-2.466.464-2.482-1.193 2.33-5.455 12.375-26.891 15.295-33.772.225-2.719-1.745-2.341-2.283-1.29-3.48 6.527-13.583 27.716-16.887 33.671-1.682.983-2.378.585-2.483-1.291 2.315-5.627 11.707-25.599 15.594-33.969.302-3.385-2.383-1.29-2.383-1.29s-13.04 26.377-16.687 33.073c-2.849 2.358-2.385-1.29-2.385-1.29s11.586-24.66 15.197-33.772c.38-3.445-2.283-.992-2.283-.992s-12.753 25.324-17.183 34.863c-.541 2.322-1.131 5.265 0 7.152 3.046 3.942 3.46 5.39.595 12.118-3.007 8.534-13.85 28.497-14.775 30.195a56.897 56.897 0 01-13.836-7.043l-.05-.037c1.04-2.181 28.767-60.371 37.556-82.98-7.366-.658-14.411 6.144-20.649 14.187-4.728 5.854-14.383 23.147-17.91 38.137-.745 3.606.111 7.707 2.037 9.06-2.085 2.548-7.061 13.582-8.056 15.807-.028-.028-.058-.053-.086-.08-10.49-10.228-17.002-24.498-17.002-40.286 0-31.109 25.282-56.328 56.469-56.328z"
          display="inline"
          filter="url(#filter11521)"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M60.117 189.934l8.476 7.493-10.799 3.372-4.507 10.377-6.544-9.229-11.261-1.079 6.754-9.076-2.453-11.044 10.719 3.62 9.745-5.746z"
          display="inline"
          filter="url(#filter11517)"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M153.145 191.984l6.625 9.171-11.276.919-6.675 9.134-4.358-10.44-10.75-3.526 8.582-7.371.032-11.314 9.662 5.885 10.77-3.466z"
          display="inline"
          filter="url(#filter11513)"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M25.517 180.901s-11.903 20.233-15.396 26.62c-.4 2.435.052 3.557 2.88 4.767 8.446 1.095 16.548 1.685 26.52 2.98 5.535 7.095 12.626 17.266 17.085 22.348 1.624.75 3.04 1.128 5.165-.695 4.79-8.91 16.885-29.798 16.885-29.798l-20.163 21.753s-10.206-14.051-14.998-19.965c-7.629-1.154-24.236-2.98-24.236-2.98z"
          display="inline"
          filter="url(#filter11509)"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M119.462 210.544s11.656 20.376 15.466 26.58c1.916 1.556 3.114 1.72 5.569-.134 5.142-6.788 9.677-13.528 15.751-21.543 8.907-1.282 21.256-2.389 27.881-3.737 1.458-1.038 2.489-2.079 1.96-4.829-5.356-8.58-17.484-29.45-17.484-29.45l8.874 28.302s-17.264 1.885-24.777 3.11c-4.788 6.049-14.617 19.559-14.617 19.559z"
          display="inline"
          filter="url(#filter11505)"
          opacity="1"
        ></path>
      </g>
      <g
        fill="#ff8f00"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.8"
        display="inline"
        transform="translate(65.454 66.806)"
        className={"medal-" + props.styleMode + "-" + props.theme}
      >
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M97.063-.93C84.251-.763 77.644 16.468 65.88 21.544c-11.821 5.101-29.03-1.828-37.926 7.305s-1.424 25.67-6.182 37.363C17.082 77.738.436 84.392.421 96.835c-.016 12.651 16.806 19.49 21.632 31.184 4.682 11.342-1.997 27.352 6.461 36.242 9.207 9.677 26.786 3.701 39.051 8.99 11.472 4.947 18.69 20.802 31.184 20.79 12.96-.014 20.42-16.473 32.308-21.633 11.732-5.092 28.669.667 37.366-8.71 8.313-8.962 1.152-24.86 5.619-36.24 4.583-11.677 21.081-18.64 21.07-31.185-.011-13.013-16.807-20.338-21.914-32.307-4.923-11.538 2.237-26.357-6.742-35.117-9.072-8.85-26.777-3.866-38.488-8.709C116.446 15.376 109.53-1.093 97.063-.93zm.563 27.414a70.633 70.633 0 0170.633 70.633 70.633 70.633 0 01-70.633 70.632 70.633 70.633 0 01-70.633-70.632 70.633 70.633 0 0170.633-70.633z"
          display="inline"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M98.608 28.732c-37.237 0-67.423 30.124-67.424 67.283 0 37.16 30.187 67.284 67.424 67.285 37.238 0 67.426-30.124 67.426-67.285 0-37.16-30.188-67.284-67.426-67.283zm-.56 11.517c31.186.001 56.466 25.22 56.466 56.328 0 31.109-25.28 56.328-56.466 56.329a56.87 56.87 0 01-10.881-1.047c.742-1.783 8.493-20.362 13.142-29.262 4.277-8.266 7.29-7.595 9.535-7.549 2.517.021 5.563-3.974 5.563-3.974s13.224-27.6 16.092-35.559c.846-2.44-1.626-2.217-2.186-.992-2.665 5.425-13.756 27.896-16.588 33.076-1.762.893-2.466.464-2.482-1.193 2.33-5.455 12.375-26.891 15.295-33.772.225-2.719-1.745-2.341-2.283-1.29-3.48 6.527-13.583 27.716-16.887 33.671-1.682.983-2.378.585-2.483-1.291 2.315-5.627 11.707-25.599 15.594-33.969.302-3.385-2.383-1.29-2.383-1.29s-13.04 26.377-16.687 33.073c-2.849 2.358-2.385-1.29-2.385-1.29s11.586-24.66 15.197-33.772c.38-3.445-2.283-.992-2.283-.992s-12.753 25.324-17.183 34.863c-.541 2.322-1.131 5.265 0 7.152 3.046 3.942 3.46 5.39.595 12.118-3.007 8.534-13.85 28.497-14.775 30.195a56.897 56.897 0 01-13.836-7.043l-.05-.037c1.04-2.181 28.767-60.371 37.556-82.98-7.366-.658-14.411 6.144-20.649 14.187-4.728 5.854-14.383 23.147-17.91 38.137-.745 3.606.111 7.707 2.037 9.06-2.085 2.548-7.061 13.582-8.056 15.807-.028-.028-.058-.053-.086-.08-10.49-10.228-17.002-24.498-17.002-40.286 0-31.109 25.282-56.328 56.469-56.328z"
          display="inline"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M60.117 189.934l8.476 7.493-10.799 3.372-4.507 10.377-6.544-9.229-11.261-1.079 6.754-9.076-2.453-11.044 10.719 3.62 9.745-5.746z"
          display="inline"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M153.145 191.984l6.625 9.171-11.276.919-6.675 9.134-4.358-10.44-10.75-3.526 8.582-7.371.032-11.314 9.662 5.885 10.77-3.466z"
          display="inline"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M25.517 180.901s-11.903 20.233-15.396 26.62c-.4 2.435.052 3.557 2.88 4.767 8.446 1.095 16.548 1.685 26.52 2.98 5.535 7.095 12.626 17.266 17.085 22.348 1.624.75 3.04 1.128 5.165-.695 4.79-8.91 16.885-29.798 16.885-29.798l-20.163 21.753s-10.206-14.051-14.998-19.965c-7.629-1.154-24.236-2.98-24.236-2.98z"
          display="inline"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M119.462 210.544s11.656 20.376 15.466 26.58c1.916 1.556 3.114 1.72 5.569-.134 5.142-6.788 9.677-13.528 15.751-21.543 8.907-1.282 21.256-2.389 27.881-3.737 1.458-1.038 2.489-2.079 1.96-4.829-5.356-8.58-17.484-29.45-17.484-29.45l8.874 28.302s-17.264 1.885-24.777 3.11c-4.788 6.049-14.617 19.559-14.617 19.559z"
          display="inline"
          opacity="1"
        ></path>
      </g>
      <g
        fill="#ff8f00"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.8"
        display="inline"
        opacity={opacity}
        transform="translate(65.454 66.806)"
        className={"3d-effect-" + props.styleMode + "-" + props.theme}
      >
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M97.063-.93C84.251-.763 77.644 16.468 65.88 21.544c-11.821 5.101-29.03-1.828-37.926 7.305s-1.424 25.67-6.182 37.363C17.082 77.738.436 84.392.421 96.835c-.016 12.651 16.806 19.49 21.632 31.184 4.682 11.342-1.997 27.352 6.461 36.242 9.207 9.677 26.786 3.701 39.051 8.99 11.472 4.947 18.69 20.802 31.184 20.79 12.96-.014 20.42-16.473 32.308-21.633 11.732-5.092 28.669.667 37.366-8.71 8.313-8.962 1.152-24.86 5.619-36.24 4.583-11.677 21.081-18.64 21.07-31.185-.011-13.013-16.807-20.338-21.914-32.307-4.923-11.538 2.237-26.357-6.742-35.117-9.072-8.85-26.777-3.866-38.488-8.709C116.446 15.376 109.53-1.093 97.063-.93zm.563 27.414a70.633 70.633 0 0170.633 70.633 70.633 70.633 0 01-70.633 70.632 70.633 70.633 0 01-70.633-70.632 70.633 70.633 0 0170.633-70.633z"
          display="inline"
          filter="url(#filter4266)"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M98.608 28.732c-37.237 0-67.423 30.124-67.424 67.283 0 37.16 30.187 67.284 67.424 67.285 37.238 0 67.426-30.124 67.426-67.285 0-37.16-30.188-67.284-67.426-67.283zm-.56 11.517c31.186.001 56.466 25.22 56.466 56.328 0 31.109-25.28 56.328-56.466 56.329a56.87 56.87 0 01-10.881-1.047c.742-1.783 8.493-20.362 13.142-29.262 4.277-8.266 7.29-7.595 9.535-7.549 2.517.021 5.563-3.974 5.563-3.974s13.224-27.6 16.092-35.559c.846-2.44-1.626-2.217-2.186-.992-2.665 5.425-13.756 27.896-16.588 33.076-1.762.893-2.466.464-2.482-1.193 2.33-5.455 12.375-26.891 15.295-33.772.225-2.719-1.745-2.341-2.283-1.29-3.48 6.527-13.583 27.716-16.887 33.671-1.682.983-2.378.585-2.483-1.291 2.315-5.627 11.707-25.599 15.594-33.969.302-3.385-2.383-1.29-2.383-1.29s-13.04 26.377-16.687 33.073c-2.849 2.358-2.385-1.29-2.385-1.29s11.586-24.66 15.197-33.772c.38-3.445-2.283-.992-2.283-.992s-12.753 25.324-17.183 34.863c-.541 2.322-1.131 5.265 0 7.152 3.046 3.942 3.46 5.39.595 12.118-3.007 8.534-13.85 28.497-14.775 30.195a56.897 56.897 0 01-13.836-7.043l-.05-.037c1.04-2.181 28.767-60.371 37.556-82.98-7.366-.658-14.411 6.144-20.649 14.187-4.728 5.854-14.383 23.147-17.91 38.137-.745 3.606.111 7.707 2.037 9.06-2.085 2.548-7.061 13.582-8.056 15.807-.028-.028-.058-.053-.086-.08-10.49-10.228-17.002-24.498-17.002-40.286 0-31.109 25.282-56.328 56.469-56.328z"
          display="inline"
          filter="url(#filter4254)"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M60.117 189.934l8.476 7.493-10.799 3.372-4.507 10.377-6.544-9.229-11.261-1.079 6.754-9.076-2.453-11.044 10.719 3.62 9.745-5.746z"
          display="inline"
          filter="url(#filter4242)"
          opacity="1"
        ></path>
        <path
          fillRule="evenodd"
          d="M153.145 191.984l6.625 9.171-11.276.919-6.675 9.134-4.358-10.44-10.75-3.526 8.582-7.371.032-11.314 9.662 5.885 10.77-3.466z"
          display="inline"
          filter="url(#filter4230)"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M25.517 180.901s-11.903 20.233-15.396 26.62c-.4 2.435.052 3.557 2.88 4.767 8.446 1.095 16.548 1.685 26.52 2.98 5.535 7.095 12.626 17.266 17.085 22.348 1.624.75 3.04 1.128 5.165-.695 4.79-8.91 16.885-29.798 16.885-29.798l-20.163 21.753s-10.206-14.051-14.998-19.965c-7.629-1.154-24.236-2.98-24.236-2.98z"
          display="inline"
          filter="url(#filter4218)"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M119.462 210.544s11.656 20.376 15.466 26.58c1.916 1.556 3.114 1.72 5.569-.134 5.142-6.788 9.677-13.528 15.751-21.543 8.907-1.282 21.256-2.389 27.881-3.737 1.458-1.038 2.489-2.079 1.96-4.829-5.356-8.58-17.484-29.45-17.484-29.45l8.874 28.302s-17.264 1.885-24.777 3.11c-4.788 6.049-14.617 19.559-14.617 19.559z"
          display="inline"
          filter="url(#filter4206)"
          opacity="1"
        ></path>
      </g>
      <g
        fill="#ff8f00"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.8"
        display="inline"
        opacity="1"
        transform="translate(65.454 66.806)"
        className={"shine-effect"}
      >
        {" "}
        <path
          // fill="#ff8f00"
          fillOpacity="1"
          stroke="none"
          strokeDasharray="none"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.8"
          d="M118.48 211.195s11.655 20.377 15.465 26.58c1.916 1.556 3.114 1.72 5.569-.134 5.142-6.788 9.677-13.528 15.751-21.543 8.906-1.282 21.255-2.389 27.881-3.737 1.457-1.038 2.489-2.079 1.96-4.829-5.356-8.58-17.484-29.45-17.484-29.45l8.873 28.302s-17.263 1.885-24.776 3.11c-4.788 6.049-14.617 19.559-14.617 19.559zm-93.946-29.643s-11.903 20.233-15.396 26.62c-.4 2.435.052 3.557 2.88 4.767 8.445 1.095 16.547 1.685 26.52 2.98 5.535 7.095 12.625 17.266 17.085 22.348 1.624.75 3.04 1.128 5.165-.695 4.79-8.91 16.885-29.798 16.885-29.798L57.51 229.527s-10.206-14.051-14.998-19.965c-7.629-1.154-24.236-2.98-24.236-2.98zm127.628 11.083l6.625 9.171-11.276.919-6.676 9.134-4.358-10.44-10.75-3.526 8.583-7.371.031-11.314 9.663 5.885 10.77-3.466zm-93.028-2.05l8.476 7.493-10.799 3.372-4.507 10.377-6.544-9.229-11.262-1.079 6.755-9.076L38.8 181.4l10.719 3.62 9.745-5.746zM97.625 29.383c-37.237 0-67.423 30.124-67.424 67.283 0 37.16 30.186 67.284 67.424 67.285 37.238 0 67.426-30.124 67.426-67.285-.001-37.16-30.188-67.284-67.426-67.283zm-.56 11.517c31.186.001 56.466 25.22 56.466 56.329 0 31.108-25.28 56.327-56.467 56.328a56.87 56.87 0 01-10.88-1.047c.742-1.783 8.493-20.362 13.142-29.262 4.277-8.266 7.289-7.595 9.535-7.549 2.516.021 5.563-3.974 5.563-3.974s13.224-27.6 16.092-35.559c.846-2.44-1.626-2.217-2.186-.992-2.665 5.425-13.756 27.897-16.588 33.076-1.763.893-2.466.464-2.482-1.193 2.33-5.455 12.375-26.891 15.295-33.772.225-2.719-1.745-2.341-2.284-1.29-3.478 6.528-13.582 27.716-16.886 33.671-1.682.983-2.379.585-2.483-1.291 2.314-5.627 11.706-25.599 15.594-33.969.302-3.385-2.383-1.29-2.383-1.29s-13.04 26.377-16.687 33.073c-2.849 2.358-2.385-1.29-2.385-1.29s11.586-24.66 15.197-33.772c.38-3.445-2.283-.992-2.283-.992s-12.753 25.324-17.184 34.863c-.54 2.322-1.13 5.265 0 7.152 3.047 3.942 3.461 5.39.596 12.118-3.007 8.534-13.85 28.497-14.775 30.195a56.897 56.897 0 01-13.836-7.043l-.05-.037c1.039-2.181 28.767-60.371 37.556-82.98-7.367-.658-14.412 6.144-20.649 14.187-4.728 5.854-14.383 23.147-17.91 38.137-.746 3.606.11 7.707 2.037 9.06-2.085 2.548-7.061 13.582-8.056 15.807l-.086-.08c-10.49-10.228-17.002-24.498-17.002-40.285 0-31.11 25.282-56.329 56.468-56.329zM96.08-.28C83.268-.111 76.661 17.12 64.896 22.196c-11.82 5.101-29.03-1.828-37.925 7.305-8.896 9.133-1.424 25.67-6.182 37.363C16.1 78.39-.548 85.043-.563 97.486c-.015 12.651 16.807 19.49 21.633 31.184 4.682 11.343-1.997 27.352 6.461 36.242 9.207 9.677 26.786 3.701 39.051 8.99 11.472 4.947 18.69 20.802 31.184 20.79 12.96-.014 20.42-16.473 32.308-21.633 11.732-5.092 28.669.667 37.365-8.71 8.314-8.962 1.153-24.86 5.62-36.24 4.583-11.677 21.081-18.64 21.07-31.185-.012-13.013-16.807-20.338-21.914-32.307-4.923-11.538 2.237-26.357-6.742-35.117-9.072-8.85-26.777-3.866-38.489-8.709C115.463 16.027 108.547-.442 96.08-.279zm.563 27.415a70.633 70.633 0 0170.632 70.633A70.633 70.633 0 0196.643 168.4 70.633 70.633 0 0126.01 97.768a70.633 70.633 0 0170.633-70.633z"
          display="inline"
          opacity="1"
          fill="url(#MyGradient)"
        />
      </g>
    </svg>
  )
}

export default Icon
